import styled from 'styled-components';

export const StyledEntryHistory = styled.div`
  width: 100%;
  max-height: 60vh;
  min-height: 40vh;
  overflow-y: auto;
  padding: 24px 28px;

  .eh-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &-table {
      > div {
        > .MuiTableContainer-root {
          min-height: calc(360px - 60px);
          max-height: calc(360px - 60px);
        }
      }
    }
  }
`;

export const StyledEntryHistoryCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const StyledEntryHistoryCard = styled.div`
  max-width: 252px;
  min-width: 252px;
  background: var(--color-ice-blue);
  padding: 14px 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;

    &:first-child {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }
  }
`;

export const StyledSpan = styled.span`
  color: var(--color-primary-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: right;
`;

export const StyledStrongSpan = styled.span`
  color: var(--color-primary-blue);
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: 4px;
`;

export const StyledSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  > h2 {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
